import { ErrorMessage } from '@hookform/error-message'
import { Checkbox, CheckboxProps, FormControlLabel, Stack, Typography } from '@mui/material'
import {
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
  UseControllerProps,
} from 'react-hook-form'

type ControledCheckboxProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = UseControllerProps<TFieldValues, TName> &
  CheckboxProps & { errors: FieldErrors<TFieldValues>; label: string }

export const ControlledCheckbox = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  errors,
  label,
}: ControledCheckboxProps<TFieldValues, TName>) => {
  return (
    <Stack spacing={0.5} useFlexGap>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox checked={field.value} />}
            onChange={(_, checked) => {
              console.log('checked', checked)
              field.onChange(checked)
            }}
            label={label}
          />
        )}
      />
      {Object.keys(errors).length > 0 ? (
        <ErrorMessage
          errors={errors}
          // @ts-expect-error no idea yet
          name={name}
          render={({ message }) => (
            <Typography color="error" variant="body2">
              {message}
            </Typography>
          )}
        />
      ) : null}
    </Stack>
  )
}
